import { render, staticRenderFns } from "./PdfTemplateImportDialog.vue?vue&type=template&id=7564d46e&"
import script from "./PdfTemplateImportDialog.vue?vue&type=script&lang=ts&"
export * from "./PdfTemplateImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAutocomplete,VCheckbox})
